import { SaferpayFieldValidationReason, SaferpayAltStatusResult, SaferpayFieldTypeEnum } from '../enums/SaferpayEnums';

export type SaferpayFieldsCallback = {
  event: string;
  fieldType: SaferpayFieldTypeEnum;
  id: string;
  isValid?: boolean;
  reason?: SaferpayFieldValidationReason;
};

export type SaferpayFieldsError = {
  message: string;
};

export type SaferpayFieldsSubmitSuccess = {
  token: string;
};

export type SaferpayAltStatus = {
  status: SaferpayAltStatusResult;
  redirectUrl: string | null;
};

export type SaferpayAliasStatus = {
  redirectUrl: string | null;
};

export type AlternativePaymentData = {
  qrCodeImage: string;
  intentUrl: string;
  requestId: string;
  expiration: string;
};
